import script from "./MainViewOrganism.vue?vue&type=script&setup=true&lang=js"
export * from "./MainViewOrganism.vue?vue&type=script&setup=true&lang=js"

import "./MainViewOrganism.vue?vue&type=style&index=0&id=6f1adc2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f1adc2a"]])

export default __exports__